<template>
    <div class="col s12 l6 offset-l2">
        <ul class="tabs" ref="tabs">
            <li class="tab col s6">
                <a href="#training" class="indigo-text text-darken-4">Entrenamiento Funcional</a>
            </li>
            <li class="tab col s6">
                <a href="#nutrition" class="indigo-text text-darken-4">Nutrici&oacute;n</a>
            </li>
        </ul>
        <div class="col s12" id="training">
            <p class="flow-text indigo-text text-darken-4">ENTRENAMIENTO FUNCIONAL</p>
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nobis quia asperiores, perspiciatis tempora, quae vel quo sunt at odit voluptatibus assumenda dolorem repudiandae adipisci nostrum possimus quasi totam facere repellat!</p>
        </div>
        <div class="col s12" id="nutrition">
            <p class="flow-text indigo-text text-darken-4">NUTRIC&Oacute;N</p>
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nobis quia asperiores, perspiciatis tempora, quae vel quo sunt at odit voluptatibus assumenda dolorem repudiandae adipisci nostrum possimus quasi totam facere repellat!</p>
        </div>
    </div> 
</template>

<script>
import M from 'materialize-css'

export default { 
    mounted() {
        // initialize tabs functionality with materliaze
        M.Tabs.init(this.$refs.tabs);
    }
}
</script>